/* Glambe buy box behaviour: packs, savings strip, cash on delivery / pay online / Tamara buttons. */
(function () {
  if (window.__gbkInit) return; window.__gbkInit = 1;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  function plain(s) { return String(s == null ? '' : s).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim(); }
  function grp(n, sep, dec) { var p = n.toFixed(dec === 0 ? 0 : 2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep); return p.join(dec === 0 ? '' : (sep === ',' ? '.' : ',')); }
  var FMT = '{{amount}}';
  function money(c) {
    var f = plain(FMT), v = c / 100;
    return f.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, grp(v, '.', 0)).replace(/\{\{\s*amount_no_decimals\s*\}\}/, grp(v, ',', 0)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.toFixed(2).replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, grp(v, ',', 2));
  }
  function mh(c) { return '<span class="money notranslate">' + money(c) + ' </span>'; }
  var cvT = 0;
  function conv() { clearTimeout(cvT); cvT = setTimeout(function () { try { if (window.bucksCC && window.bucksCC.reConvert) window.bucksCC.reConvert(); } catch (e) {} }, 80); }
  var SVG = {
    cash: '<svg class="gbk-i" viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="6" width="19" height="12" rx="2.5"/><circle cx="12" cy="12" r="2.6"/></svg>',
    lock: '<svg class="gbk-i" viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="10.5" width="17" height="10" rx="2.5"/><path d="M8 10.5V8a4 4 0 018 0v2.5"/></svg>',
    clock: '<svg class="gbk-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0116 0M12 4v8l5 3"/></svg>'
  };
  function esBtn() { return document.querySelector('.es-popup-button-product') || document.querySelector('.es-popup-button'); }

  function init(root) {
    var card = root.querySelector('[data-gbk]'); if (!card || card.__gbk) return; card.__gbk = 1;
    var jd = root.querySelector('script[data-gbp]'); if (!jd) return;
    var base = JSON.parse(jd.textContent); FMT = base.fmt || FMT;
    var form = card.closest('form'), idEl = root.querySelector('[data-id]'), qtyEl = root.querySelector('[data-quantity]');
    var btns = root.querySelector('.gbp__btns'), packs = [].slice.call(card.querySelectorAll('.gbk__pack'));
    var onlCode = (card.getAttribute('data-onl-code') || '').trim(), onlPct = parseInt(card.getAttribute('data-onl-pct'), 10) || 0;
    var onlOn = !!onlCode && onlPct > 0 && onlPct < 100, tam = card.getAttribute('data-tam') === 'true';
    if (btns && btns.parentNode !== card) card.appendChild(btns);
    if (btns) {
      btns.insertAdjacentHTML('afterbegin',
        '<button type="button" class="gbk-cod" data-gbk-cod>' + SVG.cash + '<span class="gbk-cod__t"><b>Cash on delivery</b><span data-gbk-codsub></span></span><span class="gbk-cod__go" aria-hidden="true">&rarr;</span></button>' +
        '<div class="gbk-two' + (tam ? '' : ' gbk-two--1') + '">' +
        '<button type="button" class="gbk-alt gbk-online" data-gbk-online><span class="gbk-off" data-gbk-off hidden></span><span class="gbk-row">' + SVG.lock + 'Pay online</span><span class="gbk-tot" data-gbk-ont></span><span class="gbk-sub" data-gbk-ons></span></button>' +
        (tam ? '<button type="button" class="gbk-alt gbk-tam" data-gbk-tam><span class="gbk-off" data-gbk-off hidden></span><span class="gbk-row">' + SVG.clock + 'Instalments</span><span class="gbk-tot" data-gbk-tmt></span><span class="gbk-sub" data-gbk-tms></span></button>' : '') +
        '</div>');
      btns.classList.add('gbk-on');
    }
    var $ = function (q) { return card.querySelector(q); };
    var cod = $('[data-gbk-cod]'), onB = $('[data-gbk-online]'), tmB = $('[data-gbk-tam]');
    var sticky = document.querySelector('.gbp-sticky'), snow = sticky && sticky.querySelector('[data-snow]');
    var ringFg = $('[data-gbk-fg]'), ringBox = $('[data-gbk-ring]'), pctEl = $('[data-gbk-pct]'), svb = $('[data-gbk-svb]'), lineEl = $('[data-gbk-line]'), up = $('[data-gbk-up]'), stripEl = $('[data-gbk-strip]');

    function variant() { var id = idEl ? +idEl.value : 0; for (var i = 0; i < base.variants.length; i++) if (base.variants[i].id === id) return base.variants[i]; return base.variants[0]; }
    function onPack() { for (var i = 0; i < packs.length; i++) if (packs[i].classList.contains('on')) return i; return 0; }
    function calc(v, q, p) { return { q: q, p: p, now: Math.floor(v.price * q * (100 - p) / 100), was: (v.compare > v.price ? v.compare : v.price) * q }; }
    function cur() {
      var v = variant(), q, p = 0;
      if (packs.length) { var t = packs[onPack()]; q = +t.getAttribute('data-qty'); p = +t.getAttribute('data-pct'); } else { q = +(qtyEl && qtyEl.value) || 1; }
      var c = calc(v, q, p); c.v = v; return c;
    }
    function setBusy(b, on) { if (!b) return; b.classList.toggle('is-busy', !!on); b.setAttribute('aria-busy', on ? 'true' : 'false'); }

    function renderPacks() {
      var v = variant();
      packs.forEach(function (t) {
        var c = calc(v, +t.getAttribute('data-qty'), +t.getAttribute('data-pct'));
        t.querySelector('[data-pnow]').innerHTML = mh(c.now);
        t.querySelector('[data-pwas]').innerHTML = c.was > c.now ? '<s>' + mh(c.was) + '</s>' : '';
        t.querySelector('[data-peach]').innerHTML = c.q > 1 ? mh(Math.floor(c.now / c.q)) + ' each' : '';
      });
    }
    function renderState() {
      var c = cur(), v = c.v, save = c.was - c.now, pct = c.was > 0 ? Math.round(save * 100 / c.was) : 0;
      packs.forEach(function (t, i) { t.classList.toggle('on', i === onPack()); });
      if (qtyEl && packs.length) qtyEl.value = c.q;
      if (stripEl) {
        var has = save > 0; stripEl.classList.toggle('gbk__strip--plain', !has); if (ringBox) ringBox.hidden = !has;
        if (ringFg) ringFg.style.strokeDashoffset = (113.1 * (1 - pct / 100)).toFixed(1);
        if (pctEl) pctEl.textContent = pct + '%';
        if (svb) svb.innerHTML = has ? 'You save <em>' + mh(save) + '</em>' : 'Free delivery across the GCC';
        var t = packs[onPack()]; if (lineEl && t) lineEl.textContent = t.getAttribute('data-line') || '';
        if (up) {
          var i = onPack();
          if (packs.length && i < packs.length - 1) {
            var nq = +packs[i + 1].getAttribute('data-qty'), np = +packs[i + 1].getAttribute('data-pct'), n = calc(v, nq, np);
            var extra = Math.floor(c.now / c.q) * nq - n.now;
            up.hidden = false;
            up.innerHTML = 'Add ' + (nq - c.q) + ' more' + (extra > 0 ? ', save ' + mh(extra) + ' extra' : ' for a better deal');
          } else { up.hidden = true; }
        }
      }
      var ok = !!v.available, onl = onlOn ? Math.round(c.now * (100 - onlPct) / 100) : c.now;
      if (cod) { cod.querySelector('[data-gbk-codsub]').innerHTML = ok ? 'Pay ' + mh(c.now) + ' on arrival' : 'Sold out'; cod.disabled = !ok; }
      [[onB, '[data-gbk-ont]', '[data-gbk-ons]', 'Secure card checkout'], [tmB, '[data-gbk-tmt]', '[data-gbk-tms]', 'Choose Tamara at checkout']].forEach(function (a) {
        var b = a[0]; if (!b) return;
        b.querySelector(a[1]).innerHTML = mh(onl);
        b.querySelector(a[2]).innerHTML = onlOn ? '<s>' + mh(c.now) + '</s> · ' + (a[0] === onB ? 'card checkout' : 'Tamara') : a[3];
        var off = b.querySelector('[data-gbk-off]'); if (off) { off.hidden = !onlOn; off.textContent = onlPct + '% off'; }
        b.disabled = !ok;
      });
      if (snow) snow.innerHTML = mh(c.now) + (c.q > 1 ? ' · ' + c.q + ' items' : '');
      conv();
    }
    function fixMain() {
      var v = variant(), n = root.querySelector('.gbp__now'), w = root.querySelector('.gbp__was');
      if (n) n.innerHTML = mh(v.price);
      if (w && !w.hidden && v.compare > v.price) w.innerHTML = mh(v.compare);
      conv();
    }

    card.addEventListener('change', function (e) {
      var t = e.target; if (!t || t.type !== 'radio') return;
      var lab = t.closest('.gbk__pack'), i = packs.indexOf(lab); if (i < 0 || i === onPack()) return;
      packs.forEach(function (x) { x.classList.remove('on'); }); lab.classList.add('on');
      renderState(); if (i === packs.length - 1 && packs.length > 1) confetti();
    });
    if (up) up.addEventListener('click', function () {
      var i = onPack(); if (i >= packs.length - 1) return;
      var r = packs[i + 1].querySelector('input'); r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (idEl && idEl.tagName === 'SELECT') idEl.addEventListener('change', function () { setTimeout(function () { renderPacks(); renderState(); fixMain(); }, 30); });
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-minus],[data-plus]')) setTimeout(renderState, 30); });

    if (cod) cod.addEventListener('click', function () {
      var es = esBtn(); if (es) { es.click(); return; }
      setBusy(cod, true); var t0 = Date.now();
      (function w() { var e = esBtn(); if (e) { setBusy(cod, false); e.click(); return; } if (Date.now() - t0 > 4000) { setBusy(cod, false); if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.submit(); return; } setTimeout(w, 150); })();
    });
    function go(b) {
      var c = cur(); if (!c.v.available) return; setBusy(b, true);
      var url = onlOn ? '/discount/' + encodeURIComponent(onlCode) + '?redirect=' + encodeURIComponent('/checkout') : '/checkout';
      fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: c.v.id, quantity: c.q }) }); })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { if (window.__gbkTest) { window.__gbkUrl = url; setBusy(b, false); return; } location.href = url; })
        .catch(function () { setBusy(b, false); if (window.__gbkTest) { window.__gbkUrl = 'ERR'; return; } location.href = '/cart'; });
    }
    if (onB) onB.addEventListener('click', function () { go(onB); });
    if (tmB) tmB.addEventListener('click', function () { go(tmB); });

    var sb = $('[data-gbk-share]'), fx = document.getElementById('gbfx-cfg');
    if (sb && fx && fx.dataset.share === '1') {
      sb.hidden = false;
      sb.addEventListener('click', function () {
        var text = (fx.dataset.sharetext || '').trim() || 'Bestie, look at this', url = location.origin + location.pathname;
        if (navigator.share) { navigator.share({ title: document.title, text: text, url: url }).catch(function () {}); }
        else { window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), '_blank', 'noopener'); }
      });
    }

    var cv = $('canvas.gbk__fx'), cx = cv && cv.getContext('2d'), ps = [], raf = 0;
    function confetti() {
      if (reduce || !cx) return;
      var r = cv.getBoundingClientRect(), dpr = window.devicePixelRatio || 1; cv.width = r.width * dpr; cv.height = r.height * dpr;
      var W = cv.width, H = cv.height, cols = ['#7F66B8', '#F27DAE', '#CDBDEB', '#F7E3EC', '#9A83D2']; ps = [];
      for (var i = 0; i < 46; i++) ps.push({ x: W * .5, y: H * .3, vx: (Math.random() - .5) * 14 * dpr, vy: (-Math.random() * 13 - 3) * dpr, s: (4 + Math.random() * 5) * dpr, c: cols[i % 5], r: Math.random() * 6, l: 1 });
      cancelAnimationFrame(raf);
      (function step() { cx.clearRect(0, 0, W, H); ps.forEach(function (p) { p.vy += .45 * dpr; p.x += p.vx; p.y += p.vy; p.r += .2; p.l -= .012; cx.save(); cx.globalAlpha = Math.max(0, p.l); cx.translate(p.x, p.y); cx.rotate(p.r); cx.fillStyle = p.c; cx.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2); cx.restore(); }); ps = ps.filter(function (p) { return p.l > 0; }); if (ps.length) raf = requestAnimationFrame(step); else cx.clearRect(0, 0, W, H); })();
    }

    renderState();
    [300, 1200, 3000].forEach(function (ms) { setTimeout(function () { fixMain(); renderState(); }, ms); });
    window.addEventListener('load', function () { fixMain(); conv(); });
  }
  function all() { [].forEach.call(document.querySelectorAll('.gbp-root'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();